// extracted by mini-css-extract-plugin
module.exports = {"componentsOtp":"styles_componentsOtp__3VX4Q"};